/* unplugin-vue-components disabled */import { render } from "./quick-add.vue?vue&type=template&id=9f03acd4"
import script from "./quick-add.vue?vue&type=script&lang=js"
export * from "./quick-add.vue?vue&type=script&lang=js"

import "./quick-add.vue?vue&type=style&index=0&id=9f03acd4&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__